import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Icon,
  Loading,
  Pane,
  Paneset,
} from '@folio/stripes-components';
import { CalloutContext, useOkapiKy } from '@folio/stripes-core';
import useDefaultFields from '../../../hooks/useDefaultFields';
import DefaultFieldsView from './components/DefaultFieldsView';
import ActionsMenu from '../../../shared/ActionsMenu/ActionsMenu';

function DefaultFieldsSettings({ basePath }) {
  const { defaultFields, groupedFields, isLoading, refetch } =
    useDefaultFields();

  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  const onCreate = (item) => {
    okapiKy
      .post('inventory-defaultFields', {
        timeout: 30000,
        method: 'POST',
        json: item,
      })
      .json()
      .then((res) => {
        if (res.id) {
          const message = (
            <FormattedMessage
              id="ui-plugin-inventory-templates.DefaultFieldsForm.callout.created"
              defaultMessage="Default field created successfully"
            />
          );
          context.sendCallout({ message });
          refetch();
        }
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  const onUpdate = (item) => {
    okapiKy
      .put(`inventory-defaultFields/${item.id}`, {
        timeout: 30000,
        method: 'PUT',
        headers: {
          'content-Type': 'application/json',
          accept: 'text/plain',
        },
        json: item,
      })
      .json()
      .then(() => {
        const message = (
          <FormattedMessage
            id="ui-plugin-inventory-templates.DefaultFieldsForm.callout.updated"
            defaultMessage="Default field updated successfully"
          />
        );
        context.sendCallout({ message });
        refetch();
      })
      .catch(async (err) => {
        const res = err.response;
        const text = await res.text();
        console.log('error: ', text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  return (
    <Paneset>
      <Pane
        id="inventory-plugin-template-defaultFields-list-pane"
        paneTitle={
          <FormattedMessage
            id="ui-plugin-inventory-templates.defaultFields.pane.paneTitle"
            defaultMessage="Inventory default fields"
          />
        }
        fluidContentWidth
        centeredContent
        lastMenu={
          <ActionsMenu
            contentData={defaultFields}
            fileName={
              <FormattedMessage
                id="ui-plugin-inventory-templates.defaultFields.pane.paneTitle"
                defaultMessage="Inventory default fields"
              />
            }
            permissions={{
              export: 'ui-plugin-inventory-templates.inventoryTemplates.export',
              import: 'ui-plugin-inventory-templates.inventoryTemplates.import',
            }}
            onCreate={onCreate}
            onUpdate={onUpdate}
            primaryField="name"
            visibleFields={[]}
            dataFormat="pre"
            columnMapping={{}}
          />
        }
      >
        {isLoading && <Loading size="large" />}
        {!isLoading && defaultFields?.length && (
          <DefaultFieldsView
            groupedFields={groupedFields}
            basePath={basePath}
            refetch={refetch}
          />
        )}
      </Pane>
    </Paneset>
  );
}

DefaultFieldsSettings.propTypes = {
  basePath: PropTypes.string,
};

export default DefaultFieldsSettings;
